import { OrganizationState } from 'src/modules/organization/types/OrganizationState';
import { RootState } from 'src/types/RootState';

export function getOrganizationState(state: RootState): OrganizationState {
  return state.organization;
}
